import React from "react";

import { ChevronRight as ChevronRightIcon } from "@material-ui/icons";
import { useSelector } from "react-redux";

import "../../css/admin/utils/breadcrumbs.scss";
import history from "../common/navigation/AppHistory";
import { PROJECTS_ROUTE } from "../routes/routes";

import type { JSX, ReactNode } from "react";

import type { Project } from "../../api/ProjectAPI.types";
import type { AppState } from "../../reducers";

export interface BreadcrumbItem {
  name?: ReactNode;
  url?: string;
}

interface BreadcrumbsProps {
  items?: BreadcrumbItem[];
  project?: Partial<Project>;
}

function Breadcrumbs({
  items = [],
  project: projectProp,
}: BreadcrumbsProps): JSX.Element {
  const projectFromState = useSelector(
    (state: AppState) => state.architectureReducer.project,
  );
  const project = projectProp ?? projectFromState;
  const projectSlug = project?.name ?? "";
  const displayedItems = project?.name
    ? [
        {
          name: project.name,
          url: "/dashboard",
        },
        ...items,
      ]
    : items;

  const linkItem = (item: BreadcrumbItem, index: number): JSX.Element => (
    <li key={index} className="breadcrumb-item">
      <span
        className="breadcrumb-link"
        onClick={() => {
          history.push(
            `${
              projectSlug
                ? `${PROJECTS_ROUTE}/${projectSlug}${item.url}`
                : item.url
            }`,
          );
        }}
      >
        {item.name}
      </span>
      <ChevronRightIcon className="breadcrumb-arrow" />
    </li>
  );

  const spanItem = (item: BreadcrumbItem, index: number): JSX.Element => (
    <li key={index} className="breadcrumb-item">
      <span className="breadcrumb-name">{item.name}</span>
    </li>
  );

  return (
    <nav
      className="breadcrumbs-container"
      data-testid="Breadcrumbs"
      role="navigation"
    >
      <ul className="breadcrumbs-list">
        {displayedItems.map((item, index) => {
          if (item.url) return linkItem(item, index);
          return spanItem(item, index);
        })}
      </ul>
    </nav>
  );
}

export default Breadcrumbs;
